import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import ClientForm from "@/components/ClientForm";
import { api, errMsg } from "@/lib/api";

export default function NewClient() {
  const nav = useNavigate();
  const submit = async (c) => {
    try {
      const { data } = await api.post("/clients", c);
      toast.success("Client created");
      nav(`/jobs/${data.jobs[0].id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="px-10 py-8 max-w-[1200px]">
      <div className="label-xs mb-1">Step 1 · Intake</div>
      <h1 className="text-3xl font-extrabold tracking-tight mb-1">New client intake</h1>
      <p className="text-sm text-muted-foreground mb-8">Fill in what you know now; you can edit it later. Next you'll upload the old resume, and the AI reads it automatically. Each target title becomes its own resume job.</p>
      <div className="card-surface"><ClientForm onSubmit={submit} submitLabel="Create client" /></div>
    </div>
  );
}
